module.exports = __webpack_public_path__ + "img/Pic_Logo.b8086509.png";